export const cardPage = {
    "cvv": "3 ספרות בגב הכרטיס",
    "expiry": "תוקף כרטיס",
    "card_number": "מספר כרטיס",
    "future_charge": "החיוב הראשון יתבצע ב {{date}}",
    "total_payable": "סך לתשלום",
    "payment_provider_error": "שגיאת תקשורת מול ספק התשלומים. אנא המתן מספר שניות אנחנו בודקים האם התבצע חיוב",
    "payment_error": "שגיאת תשלום, אנא נסה שוב או בדוק את פרטי הכרטיס",
    "payment_error_with_response": "שגיאת תשלום ({{response}}), אנא נסה שוב או בדוק את פרטי הכרטיס",
};
